import React from 'react';
export function Benefits() {
  return null;
}